import { render, staticRenderFns } from "./TableUserIndex.vue?vue&type=template&id=1994ff02&scoped=true&"
import script from "./TableUserIndex.vue?vue&type=script&lang=js&"
export * from "./TableUserIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994ff02",
  null
  
)

export default component.exports